module.exports = __webpack_public_path__ + "static/img/cash.b888cd48.png";